import { Group, Selections } from '@/@types/shopify';

function siblingIndex(el: Element): number {
  return el.parentElement ? Array.from(el.parentElement.children).indexOf(el) : -1;
}

export default class SwatchFilters {
  constructor(scope: string) {
    const scopeEls = Array.from(document.querySelectorAll<HTMLElement>(scope));

    const queryAll = <T extends Element>(selector: string): T[] =>
      scopeEls.flatMap((el) => Array.from(el.querySelectorAll<T>(selector)));

    const filtersContainers = queryAll<HTMLElement>('.swatch-groups-wrapper');

    let swatchColors: string[] = [];

    queryAll<HTMLElement>('.ColorSwatchList .product-form__colour-item').forEach((item) => {
      const color = item.querySelector('label')?.dataset.tooltip;

      if (color) {
        if (!swatchColors.includes(color)) {
          swatchColors.push(color);
        } else {
          item.remove();
        }
      }
    });

    let sizes: string[] = [];

    queryAll<HTMLElement>('.SizeSwatchList .HorizontalList__Item').forEach((item) => {
      const size = item.querySelector('label')?.textContent?.trim();

      if (size) {
        if (!sizes.includes(size)) {
          sizes.push(size);
        } else {
          item.remove();
        }
      }
    });

    const groups: Group[] = filtersContainers
      .map((container) => container.textContent || '')
      .join('')
      .split('$$')
      .map((item) => item.trim())
      .filter((item) => item)
      .filter(this.onlyUnique)
      .map((item) => {
        return {
          label: item,
          quantity: queryAll(`.ColorSwatchList [data-category*="${item}"]`).length,
        };
      });

    groups.unshift({
      label: 'All',
      quantity: queryAll('.ColorSwatchList [data-category]').length,
    });

    if (
      location.pathname.includes('products') &&
      scopeEls.some((el) =>
        el.closest('.ProductForm__Variants')?.querySelector('.SizeSwatch__Radio'),
      )
    ) {
      window.defer(() => {
        document
          .querySelectorAll<HTMLButtonElement>('.ProductForm__AddToCart')
          .forEach((button) => {
            button.disabled = true;
          });
      }, '.ProductForm__AddToCart');

      window.defer(() => {
        document
          .querySelectorAll<HTMLButtonElement>('.purchase-gift__footer-wrapper .ba-btn')
          .forEach((button) => {
            button.disabled = true;
          });
      }, '.purchase-gift__footer-wrapper .ba-btn');
    }

    if (groups.length === 1) return;

    const groupsHtml = groups
      .map((group) => {
        if (group.label === 'All')
          return `<a href="javascript:void(0);" class="group-option js-action active" data-action="change-swatch-group" data-group="">${group.label}<span class="group-item-count">${group.quantity}</span></a>`;
        return `<a href="javascript:void(0);" class="group-option js-action" data-action="change-swatch-group" data-group="${group.label}">${group.label}<span class="group-item-count">${group.quantity}</span></a>`;
      })
      .join('');

    const template = `<div class="carousel" data-module-init="carousel" data-options='${JSON.stringify(
      {
        slidesPerView: 3,
        slideClass: 'group-option',
        navigation: false,
        pagination: false,
      },
    )}'>
  <!-- Slider main container -->
  <div class="swiper swatch-groups">
  <!-- Additional required wrapper -->
  <div class="swiper-wrapper">
  <!-- Slides -->
  ${groupsHtml}
  </div>
  </div>
  </div>`;

    filtersContainers.forEach((container) => {
      container.innerHTML = template;
      container.classList.remove('hidden');
    });

    queryAll<HTMLInputElement>('input').forEach((input) => {
      input.addEventListener('change', () => {
        if (input.classList.contains('ColorSwatch__Radio')) {
          const selectedColor = input.value.split(' / ')[0];

          document.querySelectorAll('.ProductForm__SelectedValue').forEach((el) => {
            el.textContent = selectedColor || '';
          });
        }

        document
          .querySelectorAll<HTMLInputElement>('.QuantitySelector__CurrentQuantity')
          .forEach((qty) => {
            qty.value = '1';
          });

        const variantsContainer = input.closest('.ProductForm__Variants');

        const selections: Selections = {
          color:
            variantsContainer
              ?.querySelector<HTMLInputElement>('.ColorSwatch__Radio:checked')
              ?.value.split(' / ')[0] || '',
          size:
            variantsContainer
              ?.querySelector<HTMLInputElement>('.SizeSwatch__Radio:checked')
              ?.value.split(' / ')[1] || '',
        };

        let variant: any | undefined = window.PDP.variants.find(
          (v: any) => v.option1 == selections.color && v.option2 == selections.size,
        );

        if (!variantsContainer?.querySelector('.SizeSwatch__Radio')) {
          variant = window.PDP.variants.find((v: any) => v.option1 == selections.color);
        }

        if (variant) {
          document
            .querySelectorAll<HTMLButtonElement>('.ProductForm__AddToCart')
            .forEach((button) => {
              button.disabled = false;
            });

          document
            .querySelectorAll<HTMLButtonElement>('.purchase-gift__footer-wrapper .ba-btn')
            .forEach((button) => {
              button.disabled = false;
            });

          document.querySelectorAll<HTMLElement>('.purchase-gift__hitpoint').forEach((el) => {
            el.dataset.variantId = String(variant.id);
          });

          document
            .querySelectorAll<HTMLElement>('.product-gift-modal__viewport .add-required-to-cart')
            .forEach((el) => {
              el.dataset.variantId = String(variant.id);
            });

          window.PurchaseGiftManager.onVariantChange(variant);

          document
            .querySelectorAll<HTMLElement>('.ProductForm__AddToCart')
            .forEach((button) => {
              button.dataset.variantId = String(variant.id);
            });

          const checkedSize = document.querySelector<HTMLInputElement>('.SizeSwatch__Radio:checked');
          const colorParent =
            document.querySelector<HTMLInputElement>('.ColorSwatch__Radio:checked')?.parentElement;
          const sizeParent = checkedSize?.parentElement;

          if (checkedSize && colorParent && sizeParent) {
            const colorImagePosition = siblingIndex(colorParent) + 1;
            const newImagePosition =
              siblingIndex(sizeParent) *
                document.querySelectorAll('.product-form__colour > .js-action').length +
              colorImagePosition;

            colorParent.dataset.imagePosition = String(newImagePosition);
            colorParent.click();
          }

          document
            .querySelectorAll<HTMLInputElement>('.QuantitySelector__CurrentQuantity')
            .forEach((qty) => {
              qty.value = '1';
              qty.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }
      });
    });
  }

  private onlyUnique(value: any, index: number, array: any[]) {
    return array.indexOf(value) === index;
  }
}
